(function() {
  document.addEventListener('recommendations:loaded', function(e) {
    var section = e.detail.section;
    if (!section || section.dataset.intent !== 'related') return;

    var grid = section.querySelector('.product-recommendations-placeholder .grid');
    if (!grid) return;

    new theme.Slideshow(grid, {
      groupCells: true,
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      adaptiveHeight: false,
      setGallerySize: true
    });
  });
})();
